import { h } from 'preact'
import { useEffect, useRef, useState } from 'preact/hooks'
import { effect } from '@preact/signals-core'
import { drive_index_path } from '../../routes'
import { useDriveStore, useDriveI18n } from './drive-context.js'

function numericFolderId(id) {
  if (id == null || id === '') return null
  const n = Number(id)
  return Number.isFinite(n) ? String(n) : null
}

export function DriveFilters() {
  const store = useDriveStore()
  const i18n = useDriveI18n()
  const t = (key) => i18n.t(key)
  const inputRef = useRef(null)
  const [query, setQuery] = useState(store.searchQuery.value || '')
  const [filterType, setFilterType] = useState(store.filterType.value)

  useEffect(() => effect(() => {
    setFilterType(store.filterType.value)
    const sq = store.searchQuery.value
    if (sq != null && sq !== query && document.activeElement !== inputRef.current) {
      setQuery(sq)
    }
  }), [store])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const q = params.get('q')
    if (q) {
      setQuery(q)
      store.searchQuery.value = q
    }
  }, [store])

  function debounceSearch(value) {
    setQuery(value)
    clearTimeout(debounceSearch._t)
    debounceSearch._t = setTimeout(() => {
      const trimmed = value.trim()
      if (!trimmed) {
        clearSearch()
        return
      }
      store.searchQuery.value = trimmed
      const folderId = numericFolderId(store.currentFolder.value?.id)
      const params = new URLSearchParams({ q: trimmed })
      if (folderId) params.set('folder_id', folderId)
      window.location.href = `${drive_index_path()}/search?${params}`
    }, 400)
  }

  function clearSearch() {
    setQuery('')
    store.searchQuery.value = ''
    const folder = store.currentFolder.value
    const id = numericFolderId(folder?.id)
    window.location.href = id ? `/drive/${id}` : drive_index_path()
  }

  function setType(type) {
    store.setFilterType(type)
  }

  return (
    <div class="drive-filters px-3 pt-2 pb-1 bg-light">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-search" /></span>
            <input
              ref={inputRef}
              type="text"
              class="form-control"
              placeholder={t('drive.search_files')}
              value={query}
              autocomplete="off"
              onInput={(e) => debounceSearch(e.target.value)}
            />
            <button
              type="button"
              class={`btn btn-outline-secondary${query ? '' : ' d-none'}`}
              onClick={clearSearch}
              title={t('drive.clear_search')}
              aria-label={t('drive.clear_search')}
            >
              <i class="bi bi-x-lg" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex gap-2 justify-content-md-end mt-2 mt-md-0">
            {[
              ['all', 'bi-list-ul', 'drive.all'],
              ['folders', 'bi-folder', 'drive.folders'],
              ['files', 'bi-file-earmark', 'drive.files']
            ].map(([type, icon, key]) => (
              <button
                key={type}
                type="button"
                class={`btn btn-sm ${filterType === type ? 'btn-secondary' : 'btn-outline-secondary'}`}
                onClick={() => setType(type)}
              >
                <i class={`bi ${icon}`} />
                <span class="d-none d-lg-inline ms-1">{t(key)}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
